// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:14:28

export default {
  "id": "delivery-chaos",
  "slug": "delivery-chaos",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/99bd3235337748819b763aa490db7c72-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/99bd3235337748819b763aa490db7c72/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Delivery Chaos",
      "description": "Delivery Chaos is a fast-paced driving game where explosions turn every delivery into a challenge! Navigate through explosive mayhem, collecting waypoints to rack up coins and boost your score. Outmaneuver destruction, and unlock powerful new vehicles and exciting map areas. Can you survive the chaos and become the ultimate delivery driver?",
      "instructions": "Driving - WASD/Arrow keys / Right trigger, Left Trigger, Left stick\nHandbrake - Spacebar / Triangle\nUnlock cursor - V\nReturn to menu - Tab / Circle",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "3d",
        "car",
        "drift",
        "explosion",
        "speed"
      ]
    },
    "zh-CN": {
      "title": "配送混乱",
      "description": "《交付混乱》是一款快节奏的驾驶游戏，爆炸使每一次交付都变成挑战！在爆炸的混乱中穿梭，收集航点来积累金币并提升分数。巧妙地避开破坏，解锁强大的新车辆和激动人心的地图区域。你能在这场混乱中存活下来，成为终极的配送司机吗？",
      "instructions": "驾驶 - WASD/方向键/右扳机，左扳机，左摇杆\n手刹 - 空格键/三角形\n解锁光标 - V\n返回菜单 - Tab/圆形",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "三维",
        "汽车",
        "漂移",
        "爆炸",
        "速度"
      ]
    },
    "zh-TW": {
      "title": "配送混亂",
      "description": "Delivery Chaos 是一款快节奏的駕駛遊戲，爆炸將每一次的送貨都轉化為挑戰！穿梭於爆炸的混亂之中，收集路標以累積硬幣並提升得分。操縱車輛躲避破壞，並解鎖強大的新車輛和刺激的地圖區域。你能夠在混亂中存活下來，成為最終的送貨駕駛嗎？",
      "instructions": "駕駛 - WASD/方向鍵 / 右扳機，左扳機，左搖杆\n手煞車 - 空白鍵 / 三角形\n解除光標鎖定 - V\n返回主選單 - Tab / 圆形",
      "genres": [
        "休閒",
        "賽車與駕駛"
      ],
      "tags": [
        "3D",
        "車",
        "漂移",
        "爆炸",
        "速度"
      ]
    },
    "zh-HK": {
      "title": "配送混亂",
      "description": "送遞混亂是一個高速度的駕駛遊戲，爆炸將每一次送遞變成一項挑戰！穿梭於爆炸的混亂之中，收集路標以累積金幣並提升你的得分。操縱於毀滅之間，解鎖強力的新車輛和刺激的地圖區域。你能夠在混亂中生存下來，成為最終的送遞駕駛嗎？",
      "instructions": "駕駛 - WASD/方向鍵 / 右扳機, 左扳機, 左搖杆\n手刹 - 空格鍵 / 三角形\n解除光標鎖定 - V\n返回主選單 - Tab / 圆形",
      "genres": [
        "輕鬆",
        "賽車及駕駛"
      ],
      "tags": [
        "3D",
        "車輛",
        "漂移",
        "爆炸",
        "速度"
      ]
    },
    "ja": {
      "title": "配達大混乱",
      "description": "デリバリーチaosは、爆発で全ての配達を挑戦に変える高速ドライビングゲームです！爆発の混乱を乗り越え、ウェポイントを収集してコインを稼ぎ、スコアを高めましょう。破壊を回避し、強力な新しい車両と興味深いマップエリアを解禁しましょう。この混乱を生き延び、究極の配達ドライバーになることができますか？",
      "instructions": "ドライビング - WASD/矢印キー / 右トリガー、左トリガー、左スティック\nハンドブレーキ - スペースバー / 三角形\nカーソル解除 - V\nメニューに戻る - Tab / サークル",
      "genres": [
        "カジュアル",
        "レーシング & ドライビング"
      ],
      "tags": [
        "3D",
        "車",
        "ドリフト",
        "爆発",
        "スピード"
      ]
    },
    "ko": {
      "title": "배달 혼란",
      "description": "배달 혼란은 폭발이 모든 배달을 도전으로 만드는 빠른 속도의 드라이빙 게임입니다! 폭발적인 혼란을 통과하며 웨이포인트를 수집하여 돈을 모으고 점수를 높이세요. 파괴를 피하고 강력한 새로운 차량과 흥미로운 맵 구역을 해금하세요. 혼란 속에서 살아남고 최종 배달 드라이버가 될 수 있을까요?",
      "instructions": "드라이빙 - WASD/아이콘 키 / 오른쪽 트리거, 왼쪽 트리거, 왼쪽 스틱\n핸드브레이크 - 스페이스바 / 트리각\n커서 해제 - V\n메뉴로 돌아가기 - 탭 / 원형",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "3D",
        "자동차",
        "드리프트",
        "폭발",
        "속도"
      ]
    },
    "fr": {
      "title": "Chaos de Livraison",
      "description": "Delivery Chaos est un jeu de conduite rapide où les explosions transforment chaque livraison en un défi ! Parcourez le chaos explosif, collectez des points de passage pour accumuler des pièces et améliorer votre score. Déjouez la destruction et débloquez de nouveaux véhicules puissants et des zones de carte captivantes. Pouvez-vous survivre au chaos et devenir le conducteur de livraison ultime ?",
      "instructions": "Conduite - WASD/Touches flèches / Bouton droit, Bouton gauche, Joystick gauche\nFrein à main - Barre d'espace / Triangle\nDéverrouiller le curseur - V\nRetour au menu - Tab / Cercle",
      "genres": [
        "Casual",
        "Course et Conduite"
      ],
      "tags": [
        "3D",
        "voiture",
        "drift",
        "explosion",
        "vitesse"
      ]
    }
  }
};
